module.exports = __webpack_public_path__ + "static/img/helpingHandBackground.ed6edbeb.png";